import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path fillRule="evenodd"
          d="M11.3333333,7.02661597 L9.375,7.02661597 C9.31944444,6.31939163 8.89583333,5.84030418 8.15277778,5.84030418 C7.18055556,5.84030418 6.65277778,6.64638783 6.65277778,8 C6.65277778,9.42965779 7.19791667,10.1596958 8.13888889,10.1596958 C8.84722222,10.1596958 9.27777778,9.74524715 9.375,9.07984791 L11.3333333,9.09505703 C11.2361111,10.418251 10.1805556,12 8.09722222,12 C6.13888889,12 4.66666667,10.5893536 4.66666667,8 C4.66666667,5.39923954 6.18055556,4 8.09722222,4 C9.88888889,4 11.1805556,5.09505703 11.3333333,7.02661597 Z"/>
  </svg>
);
